import React from 'react';
import beefBanner from '../../img/cow.png';
import blockBanner from '../../img/blockchain.gif';
const HomePage = () => {
  return (
    <div>
      <div className="relative bg-cover bg-center" style={{ backgroundImage: `url(${beefBanner})`, height: '400px' }}>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="absolute inset-0 text-white flex flex-col items-center justify-center">
          <h1 className="text-5xl font-extrabold text-center">Beef Chain</h1>
          <p className="text-3xl mt-4 text-center">
            Discover the transparency and traceability of beef supply chain with blockchain technologies.
          </p>
        </div>
      </div>

      <div className="min-h-screen text-white py-8" style={{ backgroundImage: `url(${blockBanner})` }}>

        <div className="max-w-6xl mx-auto text-center">
          <div className="bg-white p-8 rounded-lg shadow-md text-gray-800 mt-8 mb-8">
            <h3 className="text-2xl font-semibold mb-4">Introduction</h3>
            <p className="text-gray-700">
              Beef is a highly perishable product and must be handled with care.
            </p>
            <p className='text-gray-700'>
            Good handling and storage practices throughout the supply chain maintain the quality of beef, as well as reduce the risk of food-borne illnesses. 
            </p>
            <p className='text-gray-700'>
            This brochure provides useful information on the good handling and storage practices of beef to maintain freshness and quality.
            </p>
          </div>

          {/* Beef Grading */}
          <div className="bg-white p-8 rounded-lg shadow-md text-gray-800 mb-8">
            <h3 className="text-2xl font-semibold mb-4">Beef Grading</h3>
            <p className="text-gray-700">
              Beef is checked for defects during the quality control process. Beef that is discolored or has an odd shape should be removed.
            </p>
            <p className="text-gray-700">
              Beef that is discolored or has an odd shape should be removed.
            </p>
            <p className="text-gray-700">
              Beef is then graded and sorted by weight for packing:
            </p>
            <div className="mt-4">
              <table className="table-auto w-full">
                <thead>
                  <tr>
                    <th className="px-4 py-2">Grade</th>
                    <th className="px-4 py-2">Weight (kg)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">Prime</td>
                    <td className="border px-4 py-2">&gt;200</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">Choice</td>
                    <td className="border px-4 py-2">150-200</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">Select</td>
                    <td className="border px-4 py-2">100-150</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-md text-gray-800 ">
            <h3 className="text-2xl text-red-700 font-semibold mb-4">Food Safety</h3>
            <p className="text-red-800">
              Beef is a highly perishable product and must be handled with care.
            </p>
            <p className="text-gray-700">
              Good handling and storage practices throughout the supply chain maintain the quality of beef, as well as reduce the risk of food-borne illnesses.
            </p>
            <p className="text-gray-700">
              This brochure provides useful information on the good handling and storage practices of beef to maintain freshness and quality.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-gray-200 py-16">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl font-extrabold mb-6">Blockchain-Powered Food Supply Chain for Beef</h2>
          <p className="text-lg mb-8">
            We are committed to revolutionizing the way we track and ensure the quality and authenticity of the food we consume. Our innovative solution leverages the power of blockchain technology, decentralized identifiers (DIDs), and verifiable credentials to provide transparency, traceability, and trust in the beef supply chain like never before.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-2xl text-gray-800">
              <h3 className="text-2xl font-semibold mb-4">Blockchain Technology</h3>
              <p className="text-gray-700">
                Our food supply chain is underpinned by blockchain, a distributed ledger technology renowned for its security and transparency. Each transaction and event in the lifecycle of a beef product is recorded on an immutable blockchain, ensuring that the data remains tamper-proof and accessible.
              </p>
            </div>

            {/* <div className="bg-white p-8 rounded-lg shadow-md text-gray-800">
              <h3 className="text-2xl font-semibold mb-4">Decentralized Identifiers (DIDs)</h3>
              <p className="text-gray-700">
                We utilize decentralized identifiers (DIDs) for each stakeholder involved in the beef supply chain. These unique identifiers are created for farmers, distributors, retailers, and consumers. DIDs help ensure that every participant in the supply chain can be uniquely identified and tracked, making it easier to pinpoint the source of any issues or inconsistencies.
              </p>
              <p className="text-gray-700 mt-4">
                DIDs provide a secure and privacy-preserving way for stakeholders to interact within the ecosystem. Your personal information is safeguarded, and you control who has access to your DID and the data associated with it.
              </p>
            </div> */}

          <div className="bg-white p-8 rounded-lg shadow-2xl text-gray-800">
              <h3 className="text-2xl font-semibold mb-4">Verifiable Credentials (VCs)</h3>
              <p className="text-gray-700">
                Our system generates verifiable credentials for each piece of beef, containing information about its source, handling, and quality. These credentials are digitally signed by the relevant stakeholders, ensuring their authenticity. Consumers can easily verify the history and quality of a piece of beef by scanning a QR code.
              </p>
              <p className="text-gray-700 mt-4">
                Verifiable credentials empower consumers with trust in the beef they purchase. They can verify the authenticity of the beef they buy, ensuring they are getting exactly what they paid for.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;